import type { Component } from "react"

import { asLockedProcess as asLockedProcessFn } from "@/lib/process_locking/asLockedProcess"

export namespace ProcessLocking {
  export type ComponentWithProcessLocking<
    Props,
    State extends LockableState
  > = Component<Props, Lockable<State>> & {
    setState: Component<Props, Lockable<State>>[`setState`]
  }

  export type Conclusion<Result> =
    | {
        error: void
        processed: false
        result: void
      }
    | {
        error: Error
        processed: true
        result: void
      }
    | {
        error: void
        processed: true
        result: Result
      }

  export type Lockable<State> = State & LockableState

  export type LockableState = { processing: string | void }

  export namespace Functions {
    export type AsLockedProcess = <
      Props,
      State extends LockableState,
      Result
    >(args: {
      component: ComponentWithProcessLocking<Props, State>
      name: string
      process: () => Result | Promise<Result>
    }) => Promise<Conclusion<Result>>
  }

  export const asLockedProcess = asLockedProcessFn
}
